'use client';

import {Icon} from '@components/@icons';
import {AnimatedFormHelperText} from '@components/@shared';
import {FormGroup, TextField, TextFieldProps} from '@mui/material';
import classNames from 'classnames';
import {FC, forwardRef} from 'react';
import styles from './MeinInput.module.css';
export interface IInputProps extends Omit<TextFieldProps, 'variant'> {
    inputClassname?: string;
    locked?: boolean;
}

export const MeinInput: FC<IInputProps> = forwardRef(function MeinInput(
    {
        className,
        helperText,
        error,
        inputClassname,
        size = 'medium',
        locked,
        ...rest
    },
    ref,
) {
    const getSlotProps = () => {
        if (locked) {
            return {
                inputLabel: {shrink: true},
                endAdornment: (
                    <Icon
                        name="lock"
                        className={styles.lockIcon}
                        color="var(--color-icon-muted)"
                    />
                ),
            };
        }

        return {
            inputLabel: {shrink: true},
        };
    };

    return (
        <FormGroup className={classNames(styles.container, className)}>
            <TextField
                variant="outlined"
                className={classNames(
                    styles.textfield,
                    styles[size],
                    inputClassname,
                )}
                margin="none"
                error={error}
                ref={ref}
                disabled={locked}
                slotProps={getSlotProps()}
                {...rest}
            />
            <AnimatedFormHelperText helperText={helperText} error={error} />
        </FormGroup>
    );
});
